module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/xabdo2-c4db47cd4067522607f3022c0b0a4ff6.jpg";